'use strict';

var import1bCtrl = ['$state', '$scope', '$timeout', 'dialog', '$translate', '$uibModal', function ($state, $scope, $timeout, dialog, $translate, $uibModal) {
    $state.importTasks = {};
    $scope.content = "";
    var _this = this;
    _this.actual = true;
    _this.deleteFirstRow = false;
    _this.data = [];
    _this.tabChar = ";"

    this.helpFile = function() {
        $uibModal.open({
            animation: true,
            controller: ['$uibModalInstance', function($uibModalInstance) {
                var _this = this;
                this.fileExample = "ID TAREA    ESTADO  EMPRESA USUARIO FECHA   INICIO  FIN\nA_1623581718	Abierta	HARVEST ENERGY S.R.L.	gomezjuan@gmail.com	2024-02-22	09:00	17:00\nA_8632057025	Abierta	PECOM	perezmaria@gmail.com	2024-02-23	10:00	18:00\nA_6322227377	Abierta	ROWING lopezana@gmail.com	2024-02-24	08:30	16:30\n"
            }],
            templateUrl: 'dashboard-tasks-advanced/imports/helpFile.html',
            controllerAs: 'modal',
            size: 'lg',
            windowClass: 'dialog',
            bindToController: true
        })
    };

	_this.clearFileInput = function () {
		if ($scope.content === '' && _this.data.length === 0) {
			_this.data = [];
			_this.deleteFirstRow = false;
            _this.getAdvancedDeleteFirstRow();
			_this.openNewFile();
		} else {
			dialog.confirm({
				title: $translate.instant("DASHBOARD.DASH_TASKS_ADVANCED.IMPORT.SELECT_FILE"),
				body: $translate.instant("DASHBOARD.DASH_TASKS_ADVANCED.DIALOG_CONFIRM.BODY"),
				accept: $translate.instant("DASHBOARD.ACCEPT"),
				cancel: $translate.instant("DASHBOARD.CANCEL"),
				size: "md",
			})
				.then(function () {
					// Clear content, data, delete first row checkbox.
					$scope.content = "";
					_this.data = [];
					_this.deleteFirstRow = false;
                    _this.getAdvancedDeleteFirstRow();

          			_this.closepage2();
					_this.closepage3();
					_this.actual = true;

					_this.openNewFile();
				});
		}
	};

	_this.openNewFile = function () {
		// Create file input, open the file selection window, asign value to content.
		var input = document.createElement('input');
		input.type = 'file';
		input.style.display = 'none';
		document.body.appendChild(input);

		input.addEventListener('change', function () {
			var file = input.files[0];
			var reader = new FileReader();
			reader.onload = function (event) {
				$scope.$apply(function () {
					$scope.content = event.target.result;
				});
			};
			reader.readAsText(file);

			_this.content = JSON.parse(JSON.stringify(reader));
		});

		input.click();
	}

    _this.processContent = function () {
		_this.closepage2();
		_this.closepage3();
		_this.actual = true;

        _this.data = [];
        var maxCol = 0;
        var tabCharValue = ';';
        if (_this.tabChar == "TAB") { tabCharValue = "\t"; }

		localStorage.setItem("advancedCharSeparator", JSON.stringify(_this.tabChar));
        localStorage.setItem("advancedDeleteFirstRow", JSON.stringify(_this.deleteFirstRow));

        var contentCopy = ($scope.content || '').replace(/^\uFEFF/, '');

        // Remove first row
        if (_this.deleteFirstRow) {
            contentCopy = contentCopy.substring(contentCopy.indexOf('\n') + 1);
        }

        var lines = contentCopy.split(/\r?\n|\r/);

        for (var j = 0; j < lines.length; j++) {
            var f = lines[j];
            var fila = {};
            if (f.trim() != "") {
                var cols = f.split(tabCharValue);
                for (var i = 0; i < cols.length; i++) {
                    var cleanData = cols[i].replace(/^["']|["']$/g, ''); // Remove single and double quotes at the beginning and end of each data.
                    fila["col" + (i + 1)] = cleanData;

                    if (i + 1 > maxCol) maxCol = i + 1;
                }
                _this.data.push(fila);
            }
        }

        _this.columnDefs = []
        for (var i = 1; i <= maxCol; i++) {
            _this.columnDefs.push({ headerName: "col" + i, field: "col" + i, width: 150, editable: true });
        }

        // $timeout is necessary to fully load the table
        $timeout(() => {
            _this.gridOptions.api.setColumnDefs(_this.columnDefs);
            _this.gridOptions.api.setRowData(_this.data);

            $state.importTasks["data"] = _this.data;
            $state.importTasks["colnumber"] = maxCol;

            _this.scrollpagedown();

            _this.gridOptions.api.sizeColumnsToFit(); // Only to update grid
        }, 300);
    }

    _this.columnDefs = [
    ];
    _this.gridOptions = {
        headerHeight: 40,
        columnDefs: _this.columnDefs,
        enableSorting: true,
        enableColResize: true,
        angularCompileRows: true,
        angularCompileFilters: true,
        angularCompileHeaders: true,
        rowData: []
    };

    this.nextStep = function() {
        _this.openpage2();
        _this.actual = false;
    }

    this.getAdvancedCharSeparator = function() {
        var separatorLocalStorage = localStorage.getItem('advancedCharSeparator');
            if (separatorLocalStorage !== "undefined" && separatorLocalStorage !== null) {
                _this.tabChar = JSON.parse(separatorLocalStorage);
            }
    }

    this.getAdvancedDeleteFirstRow = function() {
        var deleteFirstRowLocalStorage = localStorage.getItem('advancedDeleteFirstRow');
        if (deleteFirstRowLocalStorage !== "undefined" && deleteFirstRowLocalStorage !== null) {
            _this.deleteFirstRow = JSON.parse(deleteFirstRowLocalStorage);
        }
    }

    _this.getAdvancedCharSeparator();
    _this.getAdvancedDeleteFirstRow();
}];

module.exports = function () {
	return {
		restrict: 'E',
		scope: {
			openpage2: '=',
			close: '=',
			scrollpagedown: '=',
			closepage2: '=',
			closepage3: '=',
		},
		controller: import1bCtrl,
		controllerAs: 'ctrl',
		bindToController: true,
		templateUrl: 'dashboard-tasks-advanced/imports/1b.html',
	};
};
